import React, { lazy } from "react";
import { t } from "i18next";
import { RuleCreationTypeSelectorPage } from "./rule-creation/rule-creation-type-selector/RuleCreationTypeSelectorPage";
import { CashPoolingIcon } from "./shared/CashPoolingIcon";

// Lazy load components for each entrypoint
const OwnerListPage = lazy(() =>
  import("./owner-list/OwnerListPage").then((m) => ({ default: m.OwnerListPage })),
);
const RuleListPage = lazy(() =>
  import("./rule-list/RuleListPage").then((m) => ({ default: m.RuleListPage })),
);
const RuleEditPage = lazy(() =>
  import("./rule-edit/RuleEditPage").then((m) => ({ default: m.RuleEditPage })),
);
const RuleCreationFormPage = lazy(() =>
  import("./rule-creation/rule-creation-form/RuleCreationFormPage").then(
    (m) => ({ default: m.RuleCreationFormPage }),
  ),
);

const CashPoolingCredentialsPage = lazy(() =>
  import("./cash-pooling-credentials/CashPoolingCredentialsPage").then((m) => ({ default: m.CashPoolingCredentialsPage })),
);

const TransferHistoryPage = lazy(() =>
  import("./transfer-history/TransferHistoryPage").then((m) => ({ default: m.TransferHistoryPage })),
);

/**
 * Cash Pooling feature routes configuration
 *
 * Route structure:
 * - /cash-pooling/ -> list of owners (supports ?search=query)
 * - /cash-pooling/:ownerId -> list of rules for a specific owner
 * - /cash-pooling/:ownerId/rules/:ruleId/edit -> edit a specific rule
 * - /cash-pooling/rule-creation -> create a new rule
 */

// Export all routes as a single array for easier integration
export const getCashPoolingRoutes = () => [
  {
    // List of owners - /cash-pooling/
    path: "",
    key: "cash-pooling", // Use parent key for permissions
    label: "Cash Pooling",
    description: t("The intelligent way to transfer resources."),
    element: <OwnerListPage />,
    icon: <CashPoolingIcon />,
  },
  {
    path: "rule-creation",
    key: "cash-pooling-rule-creation",
    label: t("Rule Creation"),
    hiddenPageTitle: true,
    element: <RuleCreationTypeSelectorPage />,
  },
  {
    path: "rule-creation/minimum",
    label: t("Minimum Balance Rule"),
    key: "cash-pooling-rule-creation-minimum",
    element: <RuleCreationFormPage />,
    hiddenPageTitle: true,
  },
  {
    path: "rule-creation/excess",
    label: t("Excess Balance Rule"),
    key: "cash-pooling-rule-creation-excess",
    element: <RuleCreationFormPage />,
    hiddenPageTitle: true,
  },
  {
    path: "rule-creation/fixed",
    label: t("Fixed Amount Rule"),
    key: "cash-pooling-rule-creation-fixed",
    element: <RuleCreationFormPage />,
    hiddenPageTitle: true,
  },
  {
    path: "transfer-history",
    label: t("Transfer history"),
    key: "cash-pooling-transfer-history",
    element: <TransferHistoryPage />,
    hiddenPageTitle: true,
  },
  {
    // List of rules for a specific owner - /cash-pooling/:ownerId
    path: ":ownerId",
    label: "OWNER_NAME", // Dynamic label based on owner
    key: "cash-pooling-rule-list",
    element: <RuleListPage />,
    hiddenPageTitle: true,
  },
  {
    // Edit a specific rule - /cash-pooling/:ownerId/rules/:ruleId/edit
    path: ":ownerId/rules/:ruleId/edit",
    label: t("Edit Rule"),
    key: "cash-pooling-rule-edit",
    element: <RuleEditPage />,
    hiddenPageTitle: true,
  },
  {
    path: "credentials",
    label: t("Credentials"),
    key: "cash-pooling-credentials",
    element: <CashPoolingCredentialsPage />,
    hiddenPageTitle: true,
  },
];
